import React from 'react';
import { useTranslation } from 'react-i18next';

import bottomLeft from 'images/bottom_left.svg';
import bottomRight from 'images/bottom_right.svg';
import topLeft from 'images/top_left.svg';
import topRight from 'images/top_right.svg';

import CertificateArtworkInfo from '../CertificateArtworkInfo';
import CertificateFooter from '../CertificateFooter';
import CertificateHeader from '../CertificateHeader';

const CertificateFrontContent = ({ artwork, certificate, classes, downloadMode, language }) => {
  const { t } = useTranslation();

  const getPageText = () => {
    if (downloadMode === 'both') {
      if (language === 'vi') {
        return t('text_certificate_page_both_vi_front');
      }
      if (language === 'en') {
        return t('text_certificate_page_both_en_front');
      }
    }
    return t('text_certificate_page_1');
  };

  return (
    <>
      <CertificateHeader certificate={certificate} />
      <CertificateArtworkInfo
        artwork={artwork}
        certificate={certificate}
      />

      <CertificateFooter />

      <img
        src={topLeft}
        alt=""
        className={classes.cornerTopLeft}
      />
      <img
        src={topRight}
        alt=""
        className={classes.cornerTopRight}
      />
      <img
        src={bottomLeft}
        alt=""
        className={classes.cornerBottomLeft}
      />
      <img
        src={bottomRight}
        alt=""
        className={classes.cornerBottomRight}
      />
      <div className={classes.line}></div>
      <p className={classes.text_certificate_page_1}>{getPageText()}</p>
    </>
  );
};

export default CertificateFrontContent;
